import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
    getMyActiveCart,
} from "../../../../redux/hyvidstore/hyvidStoreState";
import PopupButton from "components/button/PopupButton";
import StoreModal from "./StoreModal";


const StoreAction = ({}) => {
    const dispatch = useDispatch();

    const myActiveCart = useSelector((state) => state.hyvidStore.cartDetails.data);
    useEffect(() => {
        dispatch(getMyActiveCart());
    },[dispatch]);

    return (
        <>
            <PopupButton id={`my_cart_item_history`} 
                title="History" 
                label="History"
                modalWidth={600}
                iconName="History"
                iconClass="w-5 h-5 mr-2"
                btnClass="access-button btn-history !h-10 !text-sm !px-6 !gap-2 !font-semibold"
            >
                <StoreModal 
                    cartItems={myActiveCart?.cart_items} 
                    type="history"
                />
            </PopupButton>
            
            <PopupButton id={`my_cart_items`} 
                label="Cart"
                modalWidth={600}
                iconName="ShoppingCart"
                iconClass="w-5 h-5 mr-2"
                btnClass="access-button btn-cart !font-semibold"
                badgeValue={myActiveCart?.cart_items?.reduce((sum, item) => sum + item.cri_quantity, 0)}
            >
                <StoreModal 
                    itemList={myActiveCart?.cart_items} 
                    type="cart"
                />
            </PopupButton>
        </>
    );
};

export default StoreAction;
